import { ChangeDetectionStrategy, Component, computed, effect, input, signal } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EtiquetteListComponent } from "../../../configuration/components/etiquette-list/etiquette-list";
import { FieldTextComponent, FieldWrapperComponent, FieldTextAreaComponent, AbstractComponent, FieldNumberComponent } from '@spike/scaffolds';
import { EtiquetteComponent } from "../../../configuration/components/etiquette/etiquette";
import { EntityEtiquette } from 'src/app/features/configuration/models/entity-etiquette.model';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers:[],
  imports: [CommonModule, FormsModule, EtiquetteListComponent, ReactiveFormsModule, FieldTextComponent, FieldWrapperComponent, EtiquetteComponent, FieldTextAreaComponent, FieldNumberComponent],
  selector: 'spike-organization-form',
  templateUrl: './organization-form.html'
})
export class OrganizationFormComponent extends AbstractComponent{

  //input
  entityEtiquetteList = input<EntityEtiquette[]>([]);
  etiquette= input.required<EntityEtiquette|undefined>();
  form = input.required<FormGroup>();
  formView = input<boolean>(false);

  selectedEtiquetteId = signal<number|null>(null);

  constructor(){
    super();
    effect(()=>{
      const etiquette = this.etiquette();
      this.onSelectEtiquette(etiquette && etiquette.etiquetteId ? etiquette.etiquetteId : null)
    })
  }
  etiquetteName= computed(()=>{
    const etiquette = this.etiquette();
    if(etiquette) return etiquette.shortDescription;
    else return 'default';
  })

  onSelectEtiquette(etiquetteId: number|null) {
    if(this.form() && this.form().controls && this.form().controls['etiquetteId'])
      this.form().controls['etiquetteId'].setValue(etiquetteId);
    this.selectedEtiquetteId.set(etiquetteId);
  }


}
